import {atom} from 'jotai';
import {atomEffect} from 'jotai-effect';
import {Getter, Setter} from 'jotai/index';
import {atomWithStorage} from 'jotai/vanilla/utils';
import {incrementSessionCount} from './sessionCount';

const STORAGE_KEY = 'lk-access-token';

export interface TokenDetails {
	token: string;
	expiresAt: number | string;
}

function loadStorageItem(key: string): TokenDetails | null {
	const found = localStorage.getItem(key);

	if (!found) return null;

	return JSON.parse(found);
}

export const tokenAtom = atomWithStorage<TokenDetails | null>(STORAGE_KEY, loadStorageItem(STORAGE_KEY));

export const tokenDetailsAtom = atom((get) => {
	const data = get(tokenAtom);

	if (data === null) return null;

	const [, payload] = data.token.split('.');

	return JSON.parse(atob(payload));
});

export const isAuthorizedAtom = atom((get) => Boolean(get(tokenAtom)));

export const tokenExpirationWatcherEffect = atomEffect((get: Getter, set: Setter) => {
	const token = get(tokenAtom);

	if (token === null) return;

	const now = new Date();

	if (new Date(Number(token.expiresAt) * 1000) < now) {
		incrementSessionCount();
		set(tokenAtom, null);
	}
});

